import React from "react";
import {
  DialogActions,
  Button,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  Dialog,
  Stack,
  Box,
  Avatar,
  Typography,
} from "@mui/material";


const ViewMoreDialogBox = ({ openDialogbox, handleClose, data }) => {
  return (
    <Dialog
      open={openDialogbox}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth maxWidth="md"
    >
      <DialogTitle
        variant="subtitle2"
        sx={{ fontSize: "16px", fontWeight: 600, color: "#0b3363", boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px" }}
      >
        User info
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Box className="mt-3">
            <Stack spacing={2} justifyContent={"center"} alignItems={"center"}>
              <Avatar sx={{ width: 56, height: 56 }}>
                {data
                  ? data.customerdetails.username.slice(0, 2).toUpperCase()
                  : ""}
              </Avatar>
              <Stack spacing={0.5}>
                <Typography variant="subtitle2">
                  Name : {data ? data.customerdetails.username : ""}
                </Typography>
                <Typography variant="subtitle2">
                  Email : {data ? data.customerdetails.email : ""}
                </Typography>
                <Typography variant="subtitle2">
                  Phone : {data ? data.customerdetails.phonenumber : ""}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="error" size="small" sx={{ textTransform: "capitalize !important" }}>Close</Button>
        </DialogActions>
    </Dialog>
  );
};

export default ViewMoreDialogBox;
